import api from './api';

export async function getDataDefault(path: string, id = '', query = '') {
  try {
    const url = id ? `${path}/${id}` : path;

    const urlWithQuery = query ? `${url}?${query}` : url;

    const response = await api.get(urlWithQuery);

    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}
